export enum SuccessFilter {
    All = 'all',
    Yes = 'true',
    No = 'false'
  }